/* ---------------------------------------------------------
   Shopify customer account menu — LSP styling
--------------------------------------------------------- */

document.addEventListener('DOMContentLoaded', () => {
  const account = document.querySelector('shopify-account');

  if (!account) return;

  const applyAccountStyles = () => {
    const root = account.shadowRoot;

    if (!root) {
      requestAnimationFrame(applyAccountStyles);
      return;
    }

    if (root.querySelector('#lsp-account-styles')) return;

    const style = document.createElement('style');
    style.id = 'lsp-account-styles';

    style.textContent = `
      .account__heading {
        font-family: 'Montserrat', sans-serif !important;
        font-size: 11px !important;
        line-height: 1.4 !important;
        font-weight: 600 !important;
        text-transform: uppercase !important;
        letter-spacing: 0.08em !important;
      }

      .account__email {
        font-family: 'Newsreader', serif !important;
        font-size: 12px !important;
        line-height: 1.4 !important;
      }

      .account__menu-items .button {
        font-family: 'Montserrat', sans-serif !important;
        font-size: 10px !important;
        line-height: 1.3 !important;
        font-weight: 500 !important;
        text-transform: uppercase !important;
        letter-spacing: 0.07em !important;
      }

      .account__menu-items .icon {
        width: 14px !important;
        height: 14px !important;
      }

      .account__close {
        width: 28px !important;
        height: 28px !important;
      }

      .account__close svg {
        width: 16px !important;
        height: 16px !important;
      }

      .dialog {
        border-radius: 0 !important;
      }
    `;

    root.appendChild(style);
  };

  applyAccountStyles();

  const observer = new MutationObserver(applyAccountStyles);

  observer.observe(account, {
    childList: true,
    subtree: true
  });
});